const DESCRIPTION_LABEL_TEXT = 'Descreva o lugar ou indique um ponto';
const DESCRIPTION_BUTTON_ID = 'description-action-button';

export { DESCRIPTION_LABEL_TEXT, DESCRIPTION_BUTTON_ID };
